import {FieldType} from "../../../fields3/field-type"
import {RequestFormFieldType} from "../../../../app/tools/request-forms2/const/const"
import {MandatoryFieldsIds} from "../../../../app/tools/request-forms2/@const"

export function convertFromOldFormat(data:any) {
    const res:any = {}
    res.color               = data.header.color
    res.headerTitle         = data.header.title
    res.headerDescription   = data.header.description

    const arrayOfExistingFieldIds: ID[] = []

    res.fields = _.map(data.fields, fieldConfig => {
        let field:any = {}

        switch (fieldConfig.type) {
            case 'task-field':
                switch (fieldConfig.taskField.type) {
                    case 'request-user-name'    :
                        field.type              = RequestFormFieldType.FORM
                        field.formFieldConfig   = {
                            fieldId : MandatoryFieldsIds.NAME,
                            type    : FieldType.STRING,
                        }
                        break

                    case 'request-user-email'   :
                        field.type              = RequestFormFieldType.FORM
                        field.formFieldConfig   = {
                            fieldId : MandatoryFieldsIds.EMAIL,
                            type    : FieldType.EMAIL,
                        }
                        break

                    case 'task-title'           :
                        field.type        = RequestFormFieldType.TASK
                        field.taskFieldId = MandatoryFieldsIds.TITLE
                        break

                    case 'task-priority'        :
                        field.type        = RequestFormFieldType.TASK
                        field.taskFieldId = 'priority' // gd.fields.task.priority
                        break

                    case 'task-deadline'        :
                        field.type        = RequestFormFieldType.TASK
                        field.taskFieldId = 'deadline' // gd.fields.task.deadline
                        break

                    case 'task-estimate'        :
                        field.type        = RequestFormFieldType.TASK
                        field.taskFieldId = 'estimate' // gd.fields.task.estimate
                        break

                    case 'task-assignee'        :
                        field.type        = RequestFormFieldType.TASK
                        field.taskFieldId = 'assignedToUserId' // gd.fields.task.assignedToUserId
                        break
                }

                field.label       = fieldConfig.taskField.label
                field.description = fieldConfig.taskField.description
                field.isRequired  = fieldConfig.taskField.isRequired
                field.isMandatory = fieldConfig.taskField.superSystem
                break

            case 'form-field':
                field.type        = RequestFormFieldType.FORM
                field.label       = fieldConfig.formField.label
                field.description = fieldConfig.formField.description
                field.isRequired  = fieldConfig.formField.isRequired

                const fieldId = gd.utils.generateUIDWithCollisionChecking(arrayOfExistingFieldIds)
                arrayOfExistingFieldIds.push(fieldId)

                switch (fieldConfig.formField.type) {
                    case gd.const.formFields.type.STRING     :
                        field.formFieldConfig = {
                            fieldId : fieldId,
                            type    : FieldType.STRING,
                        }
                        break

                    case gd.const.formFields.type.NUMBER     :
                        field.formFieldConfig = {
                            fieldId         : fieldId,
                            type            : FieldType.NUMBER,
                            decimalPlaces   : fieldConfig.formField.params?.decimalPlaces
                        }
                        break

                    case gd.const.formFields.type.DATE       :
                        field.formFieldConfig = {
                            fieldId         : fieldId,
                            type            : FieldType.DATE,
                        }
                        break

                    case gd.const.formFields.type.DROPDOWN   :
                        field.formFieldConfig = {
                            fieldId : fieldId,
                            type    : FieldType.DROPDOWN,
                            options : _.map(fieldConfig.formField.params?.listItems, item=>{
                                return {
                                    value       : item.id,
                                    label       : item.value,
                                    sortPosition: item.sortPosition
                                }
                            }),
                        }
                        break

                    case gd.const.formFields.type.TEXT       :
                        field.formFieldConfig = {
                            fieldId         : fieldId,
                            type            : FieldType.TEXT,
                        }
                        break
                }

                break
        }


        return field
    })

    return res
}